import RankingsLayout from "../../src/pages/rankings/RankingsLayout";
import { buildMeta } from "../routeMeta";

export function meta(args) {
  return buildMeta(
    {
      title: "Rankings — The Atlas of Economic Complexity",
      description:
        "Country and product rankings by economic complexity from the Harvard Growth Lab.",
    },
    args,
  );
}

export default RankingsLayout;
